import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

const gal1 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-01.png";
const gal2 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-02.png";
const gal3 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-03.png";
const gal4 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-04.png";

const warranty =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-05.png";

const feature =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-06.png";

const icon1 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-07.png";
const icon2 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-08.png";
const icon3 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-09.png";
const icon4 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-10.png";
const icon5 =
  "https://eclipsemattress.in/assets/images/products/healthsense-et/Healthsence-11.png";

export default function HealthSenseETPage({ location }) {
  const data = {
    galleryImages: [gal4, gal1, gal2, gal3],
    productName: "Healthsense ET",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-02.png",
    descriptionTitle: "Pocketed, Visco & Spinal Zone Patented Mattress",
    descriptionText:
      "You put your health first; choose a mattress that does the same. If you are worried about poor sleep habits and disturbed sleep cycles meet our Health sense mattress. Developed with our cutting-edge Spinal Zone and Life Edge technologies, it assures you all the additional support you need for a night of comfortable rest. Doctor-tested, Doctor-recommended mattress – so that you can sleep carefree.",
    availableSizes: "6″, 8″ & 10",
    category: { title: "Patent Series", link: "/patent-series-mattress/" },
    points: [
      "941 encased Pocketed Springs",
      "Eclipse Visco Memory Foam for pressure point relief",
      "Spinal Zone patented technology for enhanced back support",
      "Patented Life Edge Perimeter Support technology",
      "Hypoallergenic fabric & sealed seams for added protection from allergens",
    ],

    featuresText: [
      "Eclipse Memory Foam soft quilted top",
      "HD Eclipse Pure Foam",
      "Turkish Cotton Felt",
      "HD Pocket Spring System",
      "Patented Life Edge Perimeter Support",
    ],
    featuresImage: feature,
    warrantyIcons: [
      "https://eclipsemattress.in/assets/features/logo-02.png",
      "https://eclipsemattress.in/assets/features/logo-05.png",
      "https://eclipsemattress.in/assets/features/logo-06.png",
      "https://eclipsemattress.in/assets/features/logo-01.png",
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
    ],

    warrantyImage: warranty,
    price: "₹38,299 - ₹1,20,669",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    relatedProducts: [
      {
        title: "Tiara Cool",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/tiara-cool.jpg",
        link: "/patent-series-mattress/tiara-cool/",
      },
      {
        title: "Accolade PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/accolade-pt.jpg",
        link: "/patent-series-mattress/accolade-pt/",
      },
      {
        title: "Vienna ET",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/vienna-et.jpg",
        link: "/patent-series-mattress/vienna-et/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Health Sense Pocket Spring Mattress | Eclipse International"
        description="Buy Pocket spring mattress with 10 years warranty designed with Spinal Zone and Life Edge technologies gives you comfortable and carefree sleep."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-healthsenseet.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
